import api from "../config/axiosConfig";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { actionType, purposeList } from "../utils/constant";
import { hasPermission } from "../utils/utilityFunctions";
import { useSelector } from "react-redux";

export default function useRFIDetails({ rfi_id }) {
  const [rfiDetails, setRfiDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => state.profile);
  const navigate = useNavigate();

  const getRFIDetails = useCallback(
    async (rfi_id) => {
      setLoading(true);
      try {
        const response = await api.get(`/api/rfi/${rfi_id}`);

        const data = response.data || {};

        // Guard: ensure both templates exist, else redirect to Dashboard with toast
        if (data?.purpose?.purpose_name === purposeList.dimensional) {
          const componentTemplate = Boolean(data?.component_template_created);
          const paintingTemplate = Boolean(
            data?.painting_checklist_template_created
          );

          if (!componentTemplate || !paintingTemplate) {
            let message = "";
            if (!componentTemplate && !paintingTemplate) {
              message =
                "Must have component templates and painting checklist templates to proceed.";
            } else if (!componentTemplate) {
              message = "Must have component templates to proceed.";
            } else if (!paintingTemplate) {
              message = "Must have painting checklist templates to proceed.";
            }
            toast.error(message);
            navigate("/dashboard", { replace: true });
            return; // Do not update details if redirecting
          }
        }

        setRfiDetails({ ...data });
      } catch (error) {
        console.error("Error fetching RFI details:", error);
      } finally {
        setLoading(false);
      }
    },
    [navigate]
  );

  const skipStage = async ({ stage_id, skip_stage }) => {
    return await api
      .post("/api/rfi-stages/skip-stage", {
        stage_id: stage_id,
        skip_stage: skip_stage,
      })
      .then((response) => {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch((error) => {
        console.error("Error skipping stage:", error);
        return {
          success: false,
          error: error,
        };
      });
  };

  useEffect(() => {
    if (!rfi_id) return;
    if (!hasPermission(profile?.permissions?.actions, actionType.rfi_view)) {
      return;
    }
    getRFIDetails(rfi_id);
  }, [getRFIDetails, rfi_id, profile?.permissions?.actions]);

  return { rfiDetails, loading, getRFIDetails, skipStage };
}
